import React, { useState, useEffect } from 'react';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { ConfirmDialog } from 'primereact/confirmdialog';
import { useConfirmation } from '../../../common/hooks/useConfirmation';

const CertifierModal = ({ visible, onHide, certifier, onSave }) => {
  const [formData, setFormData] = useState({ name: '', description: '' });
  const [loading, setLoading] = useState(false);
  const { confirm } = useConfirmation();

  const isEdit = !!certifier;

  useEffect(() => {
    if (certifier) {
      setFormData({ name: certifier.name || '', description: certifier.description || '' });
    } else {
      setFormData({ name: '', description: '' });
    }
  }, [certifier]);

  const handleSave = async () => {
    if (!formData.name.trim()) return;

    setLoading(true);
    try {
      await onSave(formData);
      onHide();
    } catch (error) {
      // Error is handled in the hook
    } finally {
      setLoading(false);
    }
  };

  const footer = (
    <div className="flex justify-content-end gap-2">
      <Button
        label="Cancelar"
        icon="pi pi-times"
        className="p-button-secondary"
        onClick={onHide}
        disabled={loading}
      />
      <Button
        label={loading ? 'Guardando...' : 'Guardar'}
        icon={loading ? 'pi pi-spin pi-spinner' : 'pi pi-check'}
        className="p-button-primary"
        onClick={handleSave}
        disabled={loading || !formData.name.trim()}
      />
    </div>
  );

  return (
    <Dialog
      header={isEdit ? 'Editar Certificador' : 'Crear Certificador'}
      visible={visible}
      onHide={onHide}
      style={{ width: '400px' }}
      footer={footer}
      className="p-fluid"
    >
      <div className="field">
        <label htmlFor="name" className="block text-900 font-medium mb-2">
          Nombre del Certificador *
        </label>
        <InputText
          id="name"
          value={formData.name}
          onChange={(e) => setFormData({ ...formData, name: e.target.value })}
          placeholder="Ingrese el nombre del certificador"
          required
        />
      </div>
      <div className="field">
        <label htmlFor="description" className="block text-900 font-medium mb-2">
          Descripción
        </label>
        <InputText
          id="description"
          value={formData.description}
          onChange={(e) => setFormData({ ...formData, description: e.target.value })}
          placeholder="Ingrese la descripción del certificador"
        />
      </div>
    </Dialog>
  );
};

export default CertifierModal;